import React, { memo, useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { InputSelect, InputText } from "../../../components";
import {
  Button,
  CreateAlert,
  InputWraper,
  onError,
  useForm,
} from "../../../modules";
import { validationSchema } from "./../YupSchema";
import { FirmwareService } from "../../../services/firmware";

const FirmwareStatus = [
  {
    label: "Đang chờ",
    value: "NOT_CONNECTED",
  },
  {
    label: "Đã kích hoạt",
    value: "CONNECTED",
  },
  {
    label: "Đã khóa",
    value: "LOCKED",
  },
];

const FirmwareActive = [
  {
    label: "Đang kết nối",
    value: true,
  },
  {
    label: "Chưa kết nối",
    value: false,
  },
];

const Form = () => {
  const history = useHistory();
  const { id } = useParams<any>();

  const [dataDetail, setDataDetail] = useState<any>();

  const handleCancel = useCallback(() => {
    history.push("/firmwares");
  }, [history]);

  const { handleSubmit, getInputProps, isSubmitting, setValues } = useForm({
    structure: validationSchema,
    onSubmit: async (values: any) => {
      if (dataDetail?.firmwareId) {
        return FirmwareService.update(dataDetail?.firmwareId, values)
          .then(() => {
            CreateAlert({
              type: "success",
              message: "Cập nhật thiết bị thành công!",
            });
            handleCancel();
          })
          .catch(onError);
      }

      return FirmwareService.create(values)
        .then(() => {
          CreateAlert({ type: "success", message: "Tạo thiết bị thành công!" });
          handleCancel();
        })
        .catch(onError);
    },
  });

  useEffect(() => {
    if (id && id !== "create") {
      FirmwareService.getDetail(id).then((rpDataDetail) => {
        setDataDetail(rpDataDetail);

        setValues({
          code: rpDataDetail?.code,
          version: rpDataDetail?.version,
          mac: rpDataDetail?.mac,
          macWifi: rpDataDetail?.macWifi,
          status: rpDataDetail?.status,
          isActive: rpDataDetail?.isActive,
          ip: rpDataDetail?.ip,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="content">
      <form autoComplete="off" onSubmit={handleSubmit}>
        <div className="firmwares-modifi">
          <div className="firmwares-modifi-form">
            <InputWraper
              isRequired
              label={"Mã firmware"}
              inputProps={getInputProps("code")}
              component={InputText}
            />
            <InputWraper
              isRequired
              label={"Version"}
              inputProps={getInputProps("version")}
              component={InputText}
            />
            <InputWraper
              isRequired
              label={"Mac"}
              inputProps={getInputProps("mac")}
              component={InputText}
            />
            <InputWraper
              isRequired
              label={"Mac wifi"}
              inputProps={getInputProps("macWifi")}
              component={InputText}
            />
            <InputWraper
              isRequired
              label={"Trạng thái"}
              inputProps={getInputProps("isActive")}
              component={(e) => (
                <InputSelect
                  {...e}
                  options={FirmwareActive}
                  defaultValue={false}
                  isDisabled={id && id !== "create"}
                />
              )}
            />

            <InputWraper
              isRequired
              label={"Tình trạng"}
              inputProps={getInputProps("status")}
              component={(e) => (
                <InputSelect
                  {...e}
                  options={FirmwareStatus}
                  defaultValue="NOT_CONNECTED"
                />
              )}
            />
            <InputWraper
              isRequired
              label={"IP"}
              inputProps={getInputProps("ip")}
              component={InputText}
              className="col-24"
            />
          </div>
        </div>
      </form>

      <div className="btn-submit">
        <Button onClick={handleCancel} label="Hủy" isLoading={isSubmitting} />
        <Button
          buttonType="success"
          onClick={handleSubmit}
          label="Lưu"
          type="submit"
          isLoading={isSubmitting}
        />
      </div>
    </div>
  );
};

export default memo(Form);
